export const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
export const desktopMediaQuery = window.matchMedia('(min-width: 992px)');
export const billViewDesktopMediaQuery = window.matchMedia('(min-width: 1200px)');
